module.exports = __webpack_public_path__ + "img/sorting_down.97f9cfd4.svg";